import { render, staticRenderFns } from "./child-task-shenhe.vue?vue&type=template&id=54a4c8b6&scoped=true&"
import script from "./child-task-shenhe.vue?vue&type=script&lang=ts&"
export * from "./child-task-shenhe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a4c8b6",
  null
  
)

export default component.exports